import React from "react";
import ProgressBar from "react-bootstrap/ProgressBar";
import "./SkillProgress.css";

const SkillProgress = ({ name, count, progress }) => {
  return (
    <>
      <div className="progress-text d-flex justify-content-between mt-4">
        <h6 className="bold">{name}</h6>
        <p className="progressCount p-1 bold rounded">{count}</p>
      </div>
      <ProgressBar className="primary-bg" now={Number(progress)} />
    </>
  );
};

export default SkillProgress;
